import React, {Component} from 'react';
import {Button} from 'antd';

import SystemHubModalForm from './SystemHubModalForm'

class SystemHubButtonCreate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleCreate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onCreate(values)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {hub, type, style, text, ghost} = this.props
    return (<span>
      <Button type={type} style={style} icon="plus" ghost={ghost} onClick={this.showModal}>{text}</Button>
      <SystemHubModalForm title="Thêm mới hub" hub={hub} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleCreate}/>
    </span>);
  }
}

export default SystemHubButtonCreate;



// WEBPACK FOOTER //
// ./src/components/SystemHubButtonCreate.js